// extracted by mini-css-extract-plugin
module.exports = {"BooksTextInput":"BooksTextInput_BooksTextInput__25m47","isSetValue":"BooksTextInput_isSetValue__mI4RT"};